import { gql } from '@apollo/client';

export type SET_INSIGHT_ASSIGNED_USERSInputType = {
  insightId: string;
  users: {
    userId: string;
    startDate?: string | null;
    endDate?: string | null;
  }[];
};

export const SET_INSIGHT_ASSIGNED_USERS = gql`
  mutation SetInsightAssignedUsers($input: SetInsightAssignedUsersInput!) {
    data: setInsightAssignedUsers(input: $input) {
      id
      startDate
      endDate
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
